const config = {
    API_URL: "https://api.wynbytech.com",
};

export default config;